import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ButtonHelp from "@atoms/ButtonHelp";
import { ProductCard } from "@atoms/ProductCard";
import { Section } from "@atoms/Section";
import color from "@definitions/mui/color";
import Text from "@ds/components/Text";
import { formattedDate } from "@helpers/dateTime";
import useResponsive from "@helpers/useResponsive";
import Footer from "@layouts/Footer";
import useStyles from "../styles";
import dynamic from "next/dynamic";

const BreadcrumbsComponent = dynamic(() => import("@atoms/Breadcrumbs/Breadcrumbs"));

const InsightUltimateListContainer: React.FC<any> = ({ dataNavbar, insightList }) => {
  const isMobile = useResponsive("md");
  const isTablet = useResponsive("lg");
  const classes = useStyles({ isVisible: true });
  const { t } = useTranslation("common");

  const tabletPadding = isTablet ? "110px" : "auto";

  const renderSections = () => {
    if (!insightList?.data) {
      return;
    }

    const restData = insightList?.data || [];

    return (
      <Section maxWidth="full-width" pt={5} pb={3} px={tabletPadding}>
        <Container maxWidth="lg" disableGutters>
          <Grid container spacing={3}>
            {restData.map((item: any) => (
              <Grid item xs={6} mb={2} key={item.id} width={isMobile ? "100%" : undefined}>
                <ProductCard
                  title={item.title}
                  htmlDescription={item.story}
                  subTitle={formattedDate(item.date)}
                  image={item.imageUrl.mediaPath + "?tr=w-500"}
                  imageHeight={212}
                  imgQuality={50}
                  height="351px"
                  overflow="hidden"
                  withImagePlaceholder
                  titleMaxLine={1}
                  linkTo={`/insight/${item.slug}`}
                  label={item.category}
                  textColor={color.general.main}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Section>
    );
  };

  const breadcrumbCategory: string = insightList?.data[0]?.category || '';

  return (
    <Box
      className={classes.base}
      id="insight"
      sx={{
        img: {
          maxHeight: "200px",
        },
      }}
    >
      <Box mx={0} py={1} position="relative" zIndex={1} bgcolor={color.grey.mid} px="16px">
        <Container maxWidth="lg" disableGutters>
          <BreadcrumbsComponent
            homeUrl={{ label: t("root"), productPath: "/" }}
            breadcrumbs={[{ label: "Insight", productPath: "/insight" }, { label: breadcrumbCategory }]}
          />
        </Container>
      </Box>
      <Box pt="20px" pb="40px">
        <Container maxWidth="lg" disableGutters={isMobile ? false : true} sx={{ padding: tabletPadding }}>
          <Box mb={1}>
            <Text
              align={isMobile ? "center" : "left"}
              variant="h1"
              weight="700"
              sx={{ fontSize: 32 }}
            >
              {t("insight.title")}
            </Text>
          </Box>
          <Text
            variant="body1"
            weight="400"
            color="inactive-secondary"
            align={isMobile ? "center" : "left"}
            component="p"
          >
            {t("insight.desc")}
          </Text>
        </Container>
        {renderSections()}
        {/* hide for temporary, in next can be used this */}
        {/* {insightList?.data.length > 6 ?
          <Container>
            <Text
              variant="body1"
              weight="700"
              // onClick={() => router.push("/insight/list")}
              clickable
              sx={{
                color: color.primary.main,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {t("insight.more")}
            </Text>
          </Container>
          : null} */}
      </Box>
      <ButtonHelp />
      <Footer dataNavbar={dataNavbar} />
    </Box>
  );
};

export default InsightUltimateListContainer;
